import styled from "styled-components";
import { motion } from "framer-motion";

export const BodyMisRecetas = styled.div`
  display: flex;
  width: 100%;
  height: calc(100% - 20px);
  @media (max-width: 1024px) {
    flex-direction: column;
  }
  @media (max-width: 768px) {
    height: calc(100% - 98px);
  }
  .itemCardReceta {
    list-style: none;
  }
`;

export const RecetaContainerMotion = styled(motion.div)`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: calc(100% - 50px);
  padding: 40px 110px;
  overflow-y: auto;
  overflow-x: hidden;
  gap: 20px;
  @media (max-width: 1280px) {
    width: 100%;
    padding: 40px 80px;
  }
  @media (max-width: 1024px) {
    .ptur-misRecetas-tituloPagina {
      display: none;
    }
    align-items: center;
    padding: 20px;
  }
  @media (max-width: 768px) {
    padding: 10px;
  }
`;

export const CardsRecetaBoxMotion = styled(motion.ul)`
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
  ${({ $empty }) =>
    $empty &&
    `
    justify-content: center;
  `}
  @media (max-width: 1024px) {
    justify-content: center;
  }
`;

export const CardsRecetaBox = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
  @media (max-width: 768px) {
    justify-content: center;
    padding-top: 20px;
  }
`;

export const LineaSeparadora = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2px;
  margin: 10px 20px;
  background-color: var(--color-grey95);
`;

export const CardRecetaMotion = styled(motion.li)`
  width: 300px;
  height: auto;
  background-color: #ffffff;
  box-shadow:
    0px 100px 80px rgba(0, 0, 0, 0.07),
    0px 41.7776px 33.4221px rgba(0, 0, 0, 0.0503198),
    0px 22.3363px 17.869px rgba(0, 0, 0, 0.0417275),
    0px 12.5216px 10.0172px rgba(0, 0, 0, 0.035),
    0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0282725),
    0px 2.76726px 2.21381px rgba(0, 0, 0, 0.0196802);
  border-radius: 16px;
  .tituloCard {
    background: linear-gradient(257.94deg, #027bc0 18.65%, #004b76 86.55%);
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    padding: 10px 20px;
  }
  .bodyCard {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .iconContainer {
    display: flex;
    gap: 10px;
    justify-content: center;
    margin-top: 20px;
  }
  .recetaTooltip {
    width: 150px;
    margin-top: 84px;
    margin-left: 26px;
  }
  .recetaTooltipMail {
    width: 150px;
    margin-top: 68px;
    margin-left: 26px;
  }
  .recetaTooltip::before {
    top: 82%;
  }
  .recetaTooltipMail::before {
    top: 87%;
  }
`;
